import { isAdminSite } from '~/utils';

import Redirection from './components/Redirection';
import { ADMIN_REORG_REDIRECTION_CONFIG, LEARNER_REORG_REDIRECTION_CONFIG } from './config';

const ReorgRedirection = () => {
  if (isAdminSite()) {
    return <Redirection redirectionConfig={ADMIN_REORG_REDIRECTION_CONFIG} />;
  }
  return <Redirection redirectionConfig={LEARNER_REORG_REDIRECTION_CONFIG} />;
};

export default ReorgRedirection;
